import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/assets/styles/tailwind.css";
import ConfirmDialog from './components/ConfirmDialog.vue'

// 创建组件实例并挂载到 body
const ConfirmConstructor = Vue.extend(ConfirmDialog);
const confirmInstance = new ConfirmConstructor().$mount(document.createElement('div'));
document.body.appendChild(confirmInstance.$el);

// 将确认框方法挂载到 Vue 原型，方便全局调用
Vue.prototype.$confirm = function (options) {
  return confirmInstance.show(options);
};
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue(); // 轻量总线，基于Vue实例的事件系统
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
